import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PhoneNumberSchema = withDefaults({
  type: 'phone-number',
  fields: [
    {
      kind: 'attribute',
      name: 'number',
    },
    {
      kind: 'attribute',
      name: 'contactType',
    },
    {
      kind: 'attribute',
      name: 'phoneNumberType',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isVerified',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PhoneNumberSchema;
